module.exports = __webpack_public_path__ + "static/media/square-fill.eebb7876.png";